import { render, staticRenderFns } from "./screen1.vue?vue&type=template&id=2842ed7c&scoped=true&"
import script from "./screen1.vue?vue&type=script&lang=js&"
export * from "./screen1.vue?vue&type=script&lang=js&"
import style0 from "./screen1.vue?vue&type=style&index=0&id=2842ed7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2842ed7c",
  null
  
)

export default component.exports